import {
  LexicalNode,
  $applyNodeReplacement,
  DOMConversionOutput,
} from 'lexical';

import { MentionNode } from './MentionNode';

export function $createMentionNode(
  mentionId?: string,
  mentionName?: string,
  mentionLogo?: string,
  mentionType?: string,
): MentionNode {
  const mentionNode: MentionNode = new MentionNode(
    () => mentionNode.remove(),
    mentionId,
    mentionName,
    mentionLogo,
    mentionType,
  );

  return $applyNodeReplacement(mentionNode);
}

export function $isMentionNode(
  node: LexicalNode | null | undefined,
): node is MentionNode {
  return node instanceof MentionNode && !!node.getMentionId();
}

export function $convertElement(): DOMConversionOutput | null {
  const node = $createMentionNode();

  return { node };
}
